

    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorChatActivo } from '../../controlador';
    import { Item } from '@/__env/lib/Ventas/Pedidos/Item';
import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorChatActivo;

        @Prop()
        public Pedido: Pedido;

        public get Estado() { return this.Controlador.Vista.Estado; }
        public get Cliente() { return this.Pedido.Cliente; }
        public get Envio() { return this.Pedido.Envio; }
        public get Pagos() { return this.Pedido.Pagos; }

        Abrir( x: Item )
        {

        }



        AbrirPublicacion( x: string )
        {
            if ( x )
                window.open( x );
        }
    }
